var app = angular.module('leonardo');

var ExportReportDialog = function (
  $scope,
  $rootScope,
  $http,
  $window,
  $q,
  $filter,
  $timeout,
  ngDialog,
  FilterService,
  NotificationService,
  ConfigThemeService,
  DynamicFormRestService,
  FileReader,
  ReportService,
  AccountUserService,
  AuthDataService,
  FormErrorsService,
  PermissionService
) {
  $scope.reportService = ReportService;
  $scope.authDataService = AuthDataService;
  $scope.permissionService = PermissionService;
  $scope.emails = 1;


  $scope.emails_send = [];
  $scope.selectedLanguage = "";
  if (AccountUserService.currentAccountUser && AccountUserService.currentAccountUser.user) {
    $scope.emails_send.push(AccountUserService.currentAccountUser.user.email);
  } else {
    $scope.emails_send.push(AuthDataService.authData.user.email);
  }

  $scope.mode = $scope.ngDialogData.mode;
  $scope.dynamic_form = $scope.ngDialogData.dynamic_form;
  $scope.report_title = $scope.ngDialogData.report_title;
  $scope.filters = $scope.ngDialogData.filters;
  $scope.extra_fields = FilterService.filters.extra_fields || $scope.ngDialogData.filters.extra_fields;
  $scope.field_active = FilterService.filters && FilterService.filters.filters && !FilterService.filters.filters.includes('fields_active') || $scope.ngDialogData.filters && !$scope.ngDialogData.filters.fields_active ;
  $scope.is_user_report = $scope.ngDialogData.is_user_report;
  $scope.include_relevant_ids = false;
  $scope.include_score_breakdown_section = false;
  $scope.action_email = false;
  $scope.exclude_blank_responses = false;
  $scope.detailsViewReport = ReportService.getDetailsView() ? ReportService.getDetailsView() : $scope.filters.detailed;

  if ($scope.dynamic_form) {
    $scope.actions = [
      { id: 'pdf', name: 'Export PDF' },
      { id: 'excel', name: 'Export Excel' },
      { id: 'chrono_excel', name: 'Export Chronological Excel' },
      { id: 'csv', name: 'Export CSV' }
    ];
  } else if ($scope.mode === ReportService.TYPE_DYNAMIC_FORM_STATISTIC) {
    $scope.actions = [
      { id: 'excel', name: 'Export Excel' },
      { id: 'csv', name: 'Export CSV' }
    ];
  } else if ($scope.mode === ReportService.TYPE_CONTACT || $scope.mode === ReportService.TYPE_WORK_ORDER_ACTIVITY) {
    $scope.actions = [{ id: 'excel', name: 'Export Excel' }];
  }
  else if($scope.detailsViewReport){
    $scope.actions = [
      { id: 'excel', name: 'Export Excel' },
      { id: 'csv', name: 'Export CSV' }
    ];
  } else {
    $scope.actions = [
      { id: 'pdf', name: 'Export PDF' },
      { id: 'excel', name: 'Export Excel' },
      { id: 'csv', name: 'Export CSV' }
    ];
  }


  $scope.optionsLanguagewithID = AuthDataService && AuthDataService.authData && AuthDataService.authData.account && AuthDataService.authData.account.languages &&
                            AuthDataService.authData.account.languages.length > 0 ? AuthDataService.authData.account.languages : [];

  $scope.optionsLanguage = $scope.optionsLanguagewithID.map(function (lang) {
    return { "id": lang.code, "name": lang.name };
  });
  
  $scope.optionsLayout = [
    { id: '3', name: 'At the end' },
    { id: '4', name: 'Inline' }
  ];

  $scope.action = $scope.mode === ReportService.TYPE_DYNAMIC_FORM_STATISTIC || $scope.mode === ReportService.TYPE_CONTACT || $scope.mode === ReportService.TYPE_WORK_ORDER_ACTIVITY ? 'excel' : 'pdf';

  $scope.toggleValue = function(event){
    $scope.includeOriginalText = event.target.checked;
  }

  var url = window.location.href;
  var searchString = "report/dynamic";

  if (url.includes(searchString)) {
    $scope.showselectLanguageOption = true
  } else {
    $scope.showselectLanguageOption  = false
  }


  $scope.showSFTP = function () {
    var sftpTypes = [
      ReportService.TYPE_DYNAMIC_FORM_STATISTIC,
      ReportService.TYPE_DYNAMIC_FORM,
      ReportService.TYPE_ACTION_ITEM,
      ReportService.TYPE_PROPERTY_AMENITIES,
      ReportService.TYPE_ACTIVITY,
      ReportService.TYPE_UNIT,
      ReportService.TYPE_WORKFLOW,
      ReportService.TYPE_MISSING_DOCUMENTS,
      ReportService.TYPE_ON_DEMAND_INSTRUCTION,
      ReportService.TYPE_CONTACT,
      ReportService.TYPE_WORK_ORDERS,
      ReportService.TYPE_MIMO,
      ReportService.TYPE_TEMPLATE
    ];
    return sftpTypes.includes($scope.mode) && PermissionService.permissionAvailableAccount('permission_upload_sftp');
  };

  $scope.getNumberEmails = function () {
    return new Array($scope.emails);
  };

  $scope.addEmail = function () {
    $scope.emails++;
  };

  $scope.emailsError = function () {
    if (!$scope.Form.$submitted) {
      return false;
    } else if ($scope.emails_send.length === 0) {
      return true;
    } else {
      var error = true;
      angular.forEach($scope.emails_send, function (value) {
        if (value) {
          error = false;
        }
      });
      return error;
    }
  };

  $scope.addExtraFields = function (filters) {
    if(!isNull(filters['extra_fields']) && $scope.mode.toString() !== ReportService.TYPE_DYNAMIC_FORM) {
      let default_fields = [];
      if(!isNull(filters['fields_active'])) {
        default_fields = filters['fields_active'].split(',');
      } else {
        switch ($scope.mode.toString()) {
          case ReportService.TYPE_ACTION_ITEM:
            default_fields = ReportService.defaultActionItemsFields;
            break;
          case ReportService.TYPE_PROPERTY_AMENITIES:
            default_fields = ReportService.defaultFieldsReportPropertyAmenities;
            break;
          case ReportService.TYPE_PROPERTY:
            default_fields = ReportService.defaultFieldsReportProperty;
            break;
        }
      }
      const concatenated_fields = filters['extra_fields'].split(',').concat(default_fields);
      filters['fields_active'] = concatenated_fields.toString();
      delete filters.extra_fields;
    }
    return filters;
  };

  $scope.getUrlActivity = function (type) {
    var url = '';
    if (type === 'pdf') {
      url = ConfigThemeService.generateURL('/api/2.0/account-users-activity/report/export-pdf/');
    } else if (type === 'csv') {
      url = ConfigThemeService.generateURL('/api/2.0/account-users-activity/report/export-csv/');
    } else {
      url = ConfigThemeService.generateURL('/api/2.0/account-users-activity/report/export-excel/');
    }
    var filters = $scope.filters ? $scope.filters : angular.copy(FilterService.filters);
    if (type === 'csv') {
      filters['disable_pagination'] = true;
    }
    return $scope.generateUrl(url, filters);
  };

  $scope.getUrlContact = function (type) {
    var url = '';
    if (type === 'pdf') {
      url = ConfigThemeService.generateURL('/api/2.0/contacts/report/export-pdf/');
    } else if (type === 'csv') {
      url = ConfigThemeService.generateURL('/api/2.0/contacts/report/export-csv/');
    } else {
      url = ConfigThemeService.generateURL('/api/2.0/contacts/report/export-excel/');
    }
    var filters = $scope.filters ? $scope.filters : angular.copy(FilterService.filters);
    return $scope.generateUrl(url, filters);
  };

  $scope.getUrlOnDemandAccess = function (type) {
    var url = '';
    if (type === 'pdf') {
      url = ConfigThemeService.generateURL('/api/2.0/account-users-activity/on-demand-instruction/access-report/export-pdf/');
    } else if (type === 'csv') {
      url = ConfigThemeService.generateURL('/api/2.0/account-users-activity/on-demand-instruction/access-report/export-csv/');
    } else {
      url = ConfigThemeService.generateURL('/api/2.0/account-users-activity/on-demand-instruction/access-report/export-excel/');
    }
    var filters = $scope.filters ? $scope.filters : angular.copy(FilterService.filters);
    return $scope.generateUrl(url, filters);
  };

  $scope.getUrlStatistic = function (type) {
    var url = '';
    if (type === 'pdf') {
      url = ConfigThemeService.generateURL('/api/2.0/workflows-instances/report/statistics/export-pdf/');
    } else if (type === 'csv') {
      url = ConfigThemeService.generateURL('/api/2.0/workflows-instances/report/statistics/export-csv/');
    } else {
      url = ConfigThemeService.generateURL('/api/2.0/workflows-instances/report/statistics/export-excel/');
    }
    var filters = $scope.filters ? $scope.filters : angular.copy(FilterService.filters);
    return $scope.generateUrl(url, filters);
  };

  $scope.getUrlUnit = function (type) {
    var url = '';
    if (type === 'pdf') {
      url = ConfigThemeService.generateURL('/api/2.0/workflows-instances/report/phase/export-pdf/');
    } else if (type === 'csv') {
      url = ConfigThemeService.generateURL('/api/2.0/workflows-instances/report/phase/export-csv/');
    } else {
      url = ConfigThemeService.generateURL('/api/2.0/workflows-instances/report/phase/export-excel/');
    }
    var filters = $scope.filters ? $scope.filters : angular.copy(FilterService.filters);
    return $scope.generateUrl(url, filters);
  };

  $scope.getUrlTask = function (type) {
    var url = '';
    if (type === 'pdf') {
      url = ConfigThemeService.generateURL('/api/2.0/action-items/report/export-pdf/');
    } else if (type === 'csv') {
      url = ConfigThemeService.generateURL('/api/2.0/action-items/report/export-csv/');
    } else {
      url = ConfigThemeService.generateURL('/api/2.0/action-items/report/export-excel/');
    }
    var filters = $scope.filters ? $scope.filters : angular.copy(FilterService.filters);
    return $scope.generateUrl(url, filters);
  };

  $scope.getFiltersDynamic = function (dynamic_form) {
    var ordering = FilterService.getFilter('ordering');
    if (!ordering) {
      FilterService.setFilter('ordering', 'property');
    }
    var filters = $scope.filters ? $scope.filters : angular.copy(FilterService.filters);
    filters['report_title'] = $scope.report_title;
    filters['dynamic_form'] = dynamic_form || filters['dynamic_form'];

    var valid_filters = {};
    angular.forEach(filters, function (value, key) {
      if (!isNull(value)) {
        if (key === 'dynamic_filters') {
          valid_filters['dynamic_filters'] = value;
        } else if (key === 'include_tags') {
          valid_filters['include_tags'] = value;
        } else if (angular.isArray(value)) {
          valid_filters[key] = value.join(',');
        } else if (typeof value == "boolean"){
          valid_filters[key] = value;
        }
        else {
          valid_filters[key] = value.toString();
        }
      }
    });
    return valid_filters;
  };

  $scope.getUrlBilling = function (type) {
    var url = '';
    if (type === 'pdf') {
      url = ConfigThemeService.generateURL('/api/2.0/accounts/report/billing/export-pdf/');
    } else if (type === 'csv') {
      url = ConfigThemeService.generateURL('/api/2.0/accounts/report/billing/export-csv/');
    } else {
      url = ConfigThemeService.generateURL('/api/2.0/accounts/report/billing/export-excel/');
    }
    var filters = $scope.filters ? $scope.filters : angular.copy(FilterService.filters);
    return $scope.generateUrl(url, filters);
  };

  $scope.getUrlTemplate = function (type) {
    var url = '';
    if (type === 'pdf') {
      url = ConfigThemeService.generateURL('/api/2.0/templates/report/export-pdf/');
    } else if (type === 'csv') {
      url = ConfigThemeService.generateURL('/api/2.0/templates/report/export-csv/');
    } else {
      url = ConfigThemeService.generateURL('/api/2.0/templates/report/export-excel/');
    }
    var filters = $scope.filters ? $scope.filters : angular.copy(FilterService.filters);
    return $scope.generateUrl(url, filters);
  };

  $scope.getUrlProperty = function (type) {
    var url = '';
    if (type === 'pdf') {
      url = ConfigThemeService.generateURL('/api/2.0/properties/report/export-pdf/');
    } else if (type === 'csv') {
      url = ConfigThemeService.generateURL('/api/2.0/properties/report/export-csv/');
    } else {
      url = ConfigThemeService.generateURL('/api/2.0/properties/report/export-excel/');
    }
    var filters = $scope.filters ? $scope.filters : angular.copy(FilterService.filters);
    return $scope.generateUrl(url, filters);
  };

  $scope.getUrlPropertyAmenity = function (type) {
    var url = '';
    if($scope.detailsViewReport){
      if (type === 'csv') {
        url = ConfigThemeService.generateURL('/api/2.0/properties/amenities/report/detailed/export-csv/');
      } else {
        url = ConfigThemeService.generateURL('/api/2.0/properties/amenities/report/detailed/export-excel/');
      }
    }else{
      if (type === 'pdf') {
        url = ConfigThemeService.generateURL('/api/2.0/properties/amenities/report/export-pdf/');
      } else if (type === 'csv') {
        url = ConfigThemeService.generateURL('/api/2.0/properties/amenities/report/export-csv/');
      } else {
        url = ConfigThemeService.generateURL('/api/2.0/properties/amenities/report/export-excel/');
      }
    }
    
    return url;
  };

  $scope.getUrlDynamic = function (type) {
    var url = '';
    if (type === 'pdf') {
      url = ConfigThemeService.generateURL('/api/2.0/dynamic-forms-data/report/export-pdf/');
    } else if (type === 'csv') {
      url = ConfigThemeService.generateURL('/api/2.0/dynamic-forms-data/report/export-csv/');
    } else {
      url = ConfigThemeService.generateURL('/api/2.0/dynamic-forms-data/report/export-excel/');
    }
    return url;
  };

  $scope.getFiltersAmenities = function () {
    var filters = $scope.filters ? $scope.filters : angular.copy(FilterService.filters);
    filters['report_title'] = $scope.report_title;

    var valid_filters = {};
    angular.forEach(filters, function (value, key) {
      if (!isNull(value)) {
        if (key === 'lookup_filters') {
          valid_filters['lookup_filters'] = value;
        } else if (angular.isArray(value)) {
          valid_filters[key] = value.join(',');
        } else {
          valid_filters[key] = value.toString();
        }
      }
    });
    return valid_filters;
  };
  
  $scope.getUrlDocuments = function (type) {
    var url = '';
    if (type === 'pdf') {
      url = ConfigThemeService.generateURL('/api/2.0/document-folder-files/report/export-pdf/');
    } else if (type === 'csv') {
      url = ConfigThemeService.generateURL('/api/2.0/document-folder-files/report/export-csv/');
    } else {
      url = ConfigThemeService.generateURL('/api/2.0/document-folder-files/report/export-excel/');
    }
    var filters = $scope.filters ? $scope.filters : angular.copy(FilterService.filters);
    return $scope.generateUrl(url, filters);
  };

  $scope.getUrlMissingDocuments = function (type) {
    var url = '';
    if (type === 'pdf') {
      url = ConfigThemeService.generateURL('/api/2.0/missing-documents/report/export-pdf/');
    } else if (type === 'csv') {
      url = ConfigThemeService.generateURL('/api/2.0/missing-documents/report/export-csv/');
    } else {
      url = ConfigThemeService.generateURL('/api/2.0/missing-documents/report/export-excel/');
    }
    var filters = $scope.filters ? $scope.filters : angular.copy(FilterService.filters);
    return $scope.generateUrl(url, filters);
  };

  $scope.getUrlUser = function (type) {
    var url = '';
    if (type === 'pdf') {
      url = ConfigThemeService.generateURL('/api/2.0/account-users/report/export-pdf/');
    } else if (type === 'csv') {
      url = ConfigThemeService.generateURL('/api/2.0/account-users/report/export-csv/');
    } else {
      url = ConfigThemeService.generateURL('/api/2.0/account-users/report/export-excel/');
    }
    var filters = $scope.filters ? $scope.filters : angular.copy(FilterService.filters);
    return $scope.generateUrl(url, filters);
  };

  $scope.getUrlOnDemandInstruction = function (type) {
    var url = '';
    if (type !== 'pdf') {
      url = ConfigThemeService.generateURL('/api/2.0/on-demand-instructions/report/export-excel/');
    } else {
      url = ConfigThemeService.generateURL('/api/2.0/on-demand-instructions/report/export-pdf/');
    }
    var filters = $scope.filters ? $scope.filters : angular.copy(FilterService.filters);
    return $scope.generateUrl(url, filters);
  };

  $scope.getUrlWorkOrders = function (type) {
    var url = '';
    if (type === 'pdf') {
      url = ConfigThemeService.generateURL('/api/2.0/work-orders/report/export-pdf/');
    } else if (type === 'csv') {
      url = ConfigThemeService.generateURL('/api/2.0/work-orders/report/export-csv/');
    } else {
      url = ConfigThemeService.generateURL('/api/2.0/work-orders/report/export-excel/');
    }
    var filters = $scope.filters ? $scope.filters : angular.copy(FilterService.filters);
    return $scope.generateUrl(url, filters);
  };

  $scope.getUrlWorkOrderActivity = function () {
    var url = ConfigThemeService.generateURL('/api/2.0/work-orders/report/activity-report/export-excel/');
    var filters = $scope.filters ? $scope.filters : angular.copy(FilterService.filters);
    return $scope.generateUrl(url, filters);
  };

  $scope.getUrlMimo = function (type) {
    var url = '';
    if (type === 'pdf') {
      url = ConfigThemeService.generateURL('/api/2.0/mimo/report/export-pdf/');
    } else if (type === 'csv') {
      url = ConfigThemeService.generateURL('/api/2.0/mimo/report/export-csv/');
    } else {
      url = ConfigThemeService.generateURL('/api/2.0/mimo/report/export-excel/');
    }
    var filters = $scope.filters ? $scope.filters : angular.copy(FilterService.filters);
    return $scope.generateUrl(url, filters);
  };

  $scope.generateUrl = function (url, filters) {
    filters['report_title'] = $scope.report_title;
    var query = '?';
    angular.forEach(filters, function (value, key) {
      if (!isNull(value)) {
        if (angular.isArray(value)) {
          var filter = value.join(',');
          query += key + '=' + encodeURIComponent(filter) + '&';
        } else {
          query += key + '=' + (angular.isString(value) ? encodeURIComponent(value) : value) + '&';
        }
      }
    });
    query = query.slice(0, -1);
    url += query;
    return url;
  };

  $scope.share = function () {
    switch ($scope.action) {
      case 'pdf':
        return $scope.exportPDF();
      case 'excel':
      case 'chrono_excel':
        return $scope.exportExcel();
      case 'csv':
        return $scope.exportExcel('csv');
    }
  };

  $scope.logSelectedLanguage = function(selectedLanguage) {
    $scope.selectLanguage = selectedLanguage;
  };

  $scope.exportExcel = function (csv) {
    $scope.Form.$setSubmitted();
    if ($scope.emailsError()) {
      return;
    }
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    $scope.filters = $scope.addExtraFields($scope.filters || angular.copy(FilterService.filters));
    if ($scope.filters) {
      $scope.filters.response_email_recipients = $scope.emails_send.join(',');
      $scope.filters.language = $scope.selectLanguage;
      $scope.filters.include_original_text = $scope.includeOriginalText;

    } else {
      FilterService.setFilter('response_email_recipients', $scope.emails_send.join(','));
      FilterService.setFilter('language', $scope.selectLanguage);
      FilterService.setFilter('include_original_text', $scope.includeOriginalText);

    }
    $scope.loading = ngDialog.open({
      template: 'views/templates/dialog/report/loading.html',
      className: 'ngdialog-theme-default dialog-loading',
      showClose: false
    });
    var url = '';
    var promise = null;
    var filters = {};
    switch ($scope.mode.toString()) {
      case ReportService.TYPE_ACTION_ITEM:
        if (csv) {
          url = $scope.getUrlTask('csv');
        } else {
          url = $scope.getUrlTask();
        }
        break;
      case ReportService.TYPE_ACTIVITY:
        if (csv) {
          url = $scope.getUrlActivity('csv');
        } else {
          url = $scope.getUrlActivity();
        }
        break;
      case ReportService.TYPE_WORKFLOW:
      case ReportService.TYPE_UNIT:
        if (csv) {
          url = $scope.getUrlUnit('csv');
        } else {
          url = $scope.getUrlUnit();
        }
        break;
      case ReportService.TYPE_CONTACT:
        if (csv) {
          url = $scope.getUrlContact('csv');
        } else {
          url = $scope.getUrlContact();
        }
        break;
      case ReportService.TYPE_DYNAMIC_FORM:
        if (csv) {
          url = $scope.getUrlDynamic('csv');
        } else {
          url = $scope.getUrlDynamic();
        }
        break;
      case ReportService.TYPE_DYNAMIC_FORM_STATISTIC:
        if (csv) {
          url = $scope.getUrlStatistic('csv');
        } else {
          url = $scope.getUrlStatistic();
        }
        break;
      case ReportService.TYPE_BILLING:
        if (csv) {
          url = $scope.getUrlBilling('csv');
        } else {
          url = $scope.getUrlBilling();
        }
        break;
      case ReportService.TYPE_TEMPLATE:
        if (csv) {
          url = $scope.getUrlTemplate('csv');
        } else {
          url = $scope.getUrlTemplate();
        }
        break;
      case ReportService.TYPE_PROPERTY:
        if (csv) {
          url = $scope.getUrlProperty('csv');
        } else {
          url = $scope.getUrlProperty();
        }
        break;
      case ReportService.TYPE_PROPERTY_AMENITIES:
        if (csv) {
          url = $scope.getUrlPropertyAmenity('csv');
        } else {
          url = $scope.getUrlPropertyAmenity();
        }
        break;
      case ReportService.TYPE_USER:
        if (csv) {
          url = $scope.getUrlUser('csv');
        } else {
          url = $scope.getUrlUser();
        }
        break;
      case ReportService.TYPE_ON_DEMAND_INSTRUCTION:
        if (csv) {
          url = $scope.getUrlOnDemandAccess('csv');
        } else {
          url = $scope.getUrlOnDemandAccess();
        }
        break;
      case ReportService.TYPE_EXISTING_DOCUMENTS:
        if (csv) {
          url = $scope.getUrlDocuments('csv');
        } else {
          url = $scope.getUrlDocuments();
        }
        break;
      case ReportService.TYPE_MISSING_DOCUMENTS:
        if (csv) {
          url = $scope.getUrlMissingDocuments('csv');
        } else {
          url = $scope.getUrlMissingDocuments();
        }
        break;
      case ReportService.TYPE_WORK_ORDERS:
        if (csv) {
          url = $scope.getUrlWorkOrders('csv');
        } else {
          url = $scope.getUrlWorkOrders();
        }
        break;
      case ReportService.TYPE_MIMO:
        if (csv) {
          url = $scope.getUrlMimo('csv');
        } else {
          url = $scope.getUrlMimo();
        }
        break;
      case ReportService.TYPE_WORK_ORDER_ACTIVITY:
        url = $scope.getUrlWorkOrderActivity();
        break;
    }
    if ($scope.mode.toString() === ReportService.TYPE_DYNAMIC_FORM) {
      filters = $scope.getFiltersDynamic($scope.dynamic_form);
      if ($scope.action_email) {
        filters['response_type'] = 2;
      }
      if ($scope.include_score_breakdown_section) {
        filters['include_score_breakdown_section'] = true;
      }
      if ($scope.include_relevant_ids) {
        filters['include_relevant_ids'] = true;
      }
      if ($scope.exclude_blank_responses) {
        filters['exclude_blank_responses'] = true;
      }
      if ($scope.action === 'chrono_excel') {
        filters['chronological_layout'] = true;
      }
      if (filters) {
        filters['fetch_resident'] = true;
      }
      promise = $http.post(url, filters);
    } else if ($scope.mode.toString() === ReportService.TYPE_PROPERTY_AMENITIES) {
      filters = $scope.getFiltersAmenities();
      if ($scope.action_email) {
        filters['response_type'] = 2;
      }
      promise = $http.post(url, filters);
    } else {
      if ($scope.action_email) {
        url += '&response_type=2';
      }
      if ($scope.mode.toString() === ReportService.TYPE_WORK_ORDERS) {
        url += '&fetch_resident=true';
      }
      promise = $http.get(url);
    }

    promise.then(
      function () {
        promiseResolve();
      },
      function () {
        $scope.loading.close();
      }
    );
  };

  $scope.exportPDF = function () {
    $scope.Form.$setSubmitted();
    if ($scope.emailsError()) return;
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    $scope.filters = $scope.addExtraFields($scope.filters || angular.copy(FilterService.filters));
    if ($scope.filters) {
      $scope.filters.response_email_recipients = $scope.emails_send.join(',');
      $scope.filters.language = $scope.selectLanguage;
      $scope.filters.include_original_text = $scope.includeOriginalText;
    }
    else {
      FilterService.setFilter('response_email_recipients', $scope.emails_send.join(','));
      FilterService.setFilter('language', $scope.selectLanguage);
      FilterService.setFilter('include_original_text', $scope.includeOriginalText);
    }
    $scope.loading = ngDialog.open({
      template: 'views/templates/dialog/report/loading.html',
      className: 'ngdialog-theme-default dialog-loading',
      showClose: false
    });
    var url = '';
    var promise = null;
    var filters = {};
    switch ($scope.mode.toString()) {
      case ReportService.TYPE_ACTION_ITEM:
        url = $scope.getUrlTask('pdf');
        break;
      case ReportService.TYPE_ACTIVITY:
        url = $scope.getUrlActivity('pdf');
        break;
      case ReportService.TYPE_UNIT:
      case ReportService.TYPE_WORKFLOW:
        url = $scope.getUrlUnit('pdf');
        break;
      case ReportService.TYPE_CONTACT:
        url = $scope.getUrlContact('pdf');
        break;
      case ReportService.TYPE_DYNAMIC_FORM:
        url = $scope.getUrlDynamic('pdf');
        break;
      case ReportService.TYPE_DYNAMIC_FORM_STATISTIC:
        url = $scope.getUrlStatistic('pdf');
        break;
      case ReportService.TYPE_BILLING:
        url = $scope.getUrlBilling('pdf');
        break;
      case ReportService.TYPE_TEMPLATE:
        url = $scope.getUrlTemplate('pdf');
        break;
      case ReportService.TYPE_PROPERTY:
        url = $scope.getUrlProperty('pdf');
        break;
      case ReportService.TYPE_PROPERTY_AMENITIES:
        url = $scope.getUrlPropertyAmenity('pdf');
        break;
      case ReportService.TYPE_USER:
        url = $scope.getUrlUser('pdf');
        break;
      case ReportService.TYPE_ON_DEMAND_INSTRUCTION:
        url = $scope.getUrlOnDemandAccess('pdf');
        break;
      case ReportService.TYPE_EXISTING_DOCUMENTS:
        url = $scope.getUrlDocuments('pdf');
        break;
      case ReportService.TYPE_MISSING_DOCUMENTS:
        url = $scope.getUrlMissingDocuments('pdf');
        break;
      case ReportService.TYPE_WORK_ORDERS:
        url = $scope.getUrlWorkOrders('pdf');
        break;
      case ReportService.TYPE_WORK_ORDER_ACTIVITY:
        url = $scope.getUrlWorkOrderActivity();
        break;
      case ReportService.TYPE_MIMO:
        url = $scope.getUrlMimo('pdf');
        break;
    }
    if ($scope.mode.toString() === ReportService.TYPE_DYNAMIC_FORM) {
      filters = $scope.getFiltersDynamic($scope.dynamic_form);
      if ($scope.action_email) {
        filters['response_type'] = 2;
      }
      if (filters) {
        filters['fetch_resident'] = true;
      }
      promise = $http.post(url, filters);
    } else if ($scope.mode.toString() === ReportService.TYPE_PROPERTY_AMENITIES) {
      filters = $scope.getFiltersAmenities();
      if ($scope.action_email) {
        filters['response_type'] = 2;
      }
      promise = $http.post(url, filters);
    } else {
      if ($scope.action_email) {
        url += '&response_type=2';
      }
      if ($scope.mode.toString() === ReportService.TYPE_WORK_ORDERS) {
        url += '&fetch_resident=true';
      }
      promise = $http.get(url);
    }

    promise.then(
      function () {
        promiseResolve();
      },
      function () {
        $scope.loading.close();
      }
    );
  };

  function promiseResolve() {
    $scope.loading.close();
    NotificationService.notify('success', 'An email will be sent to you in a few moments.');
    $scope.closeThisDialog();
  }

  $scope.updateLayout = function () {
    if ($scope.action !== 'pdf') {
      $scope.filters.theme_layout = '';
    }
  };
};

app.controller('ExportReportDialog', [
  '$scope',
  '$rootScope',
  '$http',
  '$window',
  '$q',
  '$filter',
  '$timeout',
  'ngDialog',
  'FilterService',
  'NotificationService',
  'ConfigThemeService',
  'DynamicFormRestService',
  'FileReader',
  'ReportService',
  'AccountUserService',
  'AuthDataService',
  'FormErrorsService',
  'PermissionService',
  ExportReportDialog
]);
